import React, { useEffect, useState } from "react";
import Pagination from "../../components/Pagination";
import { FaPlus } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  GetVideo,
  classNa,
  dateSelect,
  division,
  year,
} from "../../utils/EndPoints";
import axiosInstance from "../../utils/Axios";
import VideoClassTable from "../../components/videoClass/VideoClassTable";
import StudentLoader from "../../components/loading/StudentLoader";

const ViewVideoClass = () => {
  const [data, setData] = useState({});
  const [classData, setClassData] = useState([]);
  const [yearData, setYearData] = useState([]);
  const [divisionData, setDivisionData] = useState([]);
  const [dateData, setDateData] = useState([]);
  const [page, setPage] = useState(1);
  const [entries, setEntries] = useState(100);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    batch_year: "",
    class_name: "",
    division: "",
    date: "",
  });

  const getAllData = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `${GetVideo}?page=${page}&count=${entries}`
      );
      console.log(response?.data);
      setFormData({
        batch_year: response?.data?.batch_year,
        class_name: response?.data?.class_name,
        division: response?.data?.division,
      });
      setData(response?.data);
    } catch (error) {
      console.log(error);
      if (error?.response?.data?.msg === "Invalid page.") {
        setData([]);
      }
    } finally {
      setLoading(false);
    }
  };

  const updateData = async (e) => {
    setLoading(true);
    console.log(page);
    try {
      const response = await axiosInstance.get(
        `${GetVideo}?batch_year=${formData.batch_year}&class_name=${formData.class_name}&division=${formData.division}&date=${formData?.date}&subject=${formData?.subject}&page=${page}&count=${entries}`
      );
      setData(response?.data);
    } catch (error) {
      console.log(error);
      if (error?.response?.data?.detail === "Invalid page.") {
        setData();
      }
    } finally {
      setLoading(false);
    }
  };

  const inputChangeHandler = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `${GetVideo}?batch_year=${formData.batch_year}&class_name=${formData.class_name}&division=${formData.division}&date=${formData?.date}`
      );
      setData(response?.data);
    } catch (error) {
      console.log(error);
      toast.error("Something Went Wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllData();
    window.scrollTo(0, 0);

    axiosInstance
      .get(year)
      .then((res) => {
        setYearData(res?.data?.batch_year);
      })
      .catch((error) => {
        console.log(error);
      });
    axiosInstance
      .get(classNa)
      .then((res) => {
        setClassData(res?.data?.class_name);
      })
      .catch((error) => {
        console.log(error);
      });
    axiosInstance
      .get(division)
      .then((res) => {
        setDivisionData(res?.data?.division);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (formData.batch_year && formData.class_name && formData.division) {
      axiosInstance
        .get(
          `${dateSelect}?batch_year=${formData.batch_year}&class_name=${formData.class_name}&division=${formData.division}`
        )
        .then((res) => {
          setDateData(res?.data?.distinct_dates);
        })
        .catch((error) => {
          toast.warning(error?.response?.data?.message);
          console.log(error);
        });
    }
  }, [formData.batch_year, formData.class_name, formData.division]);

  return (
    <div>
      {/* add class link button */}
      <div className="flex flex-col md:flex-row items-center md:justify-between gap-3">
        <h1 className="font-mono font-bold text-2xl text-[#F4881F]">
          Video Links{" "}
        </h1>
        <div className="">
          <h1 className="font-semibold text-lg font-mono text-[#F4881F] uppercase">
            {data?.class_name} - <span>{data?.division}</span> -{" "}
            <span>{data?.batch_year}</span>
          </h1>
        </div>
        <div className="flex items-center gap-3">
          <Link
            to={"/dashboard/video-class"}
            className="bg-[#F4881F] p-2 rounded text-white shadow-lg hover:scale-105 ease-in-out duration-300"
          >
            <div className="flex items-center gap-2">
              <FaPlus />
              Add New Vide Link
            </div>
          </Link>
        </div>
      </div>

      {/* Filter Part */}
      <div className="flex flex-col gap-5 mt-8">
        <form
          onSubmit={submitHandler}
          action=""
          className="w-full gap-5 flex flex-col md:flex-row"
        >
          <div className="w-full flex flex-col items-start">
            <label htmlFor="" className="mb-2 font-medium">
              Select Class
            </label>
            <select
              name="class_name"
              onChange={inputChangeHandler}
              id=""
              className="rounded text-sm w-full border border-[#F4881F]/30 p-2 focus:outline-none"
            >
              <option value="">Choose A Class</option>
              {classData.map((items, i) => (
                <option key={i} value={items}>
                  {items}
                </option>
              ))}
            </select>
          </div>

          <div className=" w-full flex flex-col items-start">
            <label htmlFor="" className="mb-2 font-medium">
              Select Division
            </label>
            <select
              name="division"
              onChange={inputChangeHandler}
              id=""
              className="rounded text-sm w-full border border-[#F4881F]/30 p-2 focus:outline-none"
            >
              <option value="">Choose A Division</option>
              {divisionData.map((items, i) => (
                <option key={i} value={items}>
                  {items}
                </option>
              ))}
            </select>
          </div>

          <div className="w-full flex flex-col items-start">
            <label htmlFor="" className="mb-2 font-medium">
              Select A Year
            </label>
            <select
              name="batch_year"
              onChange={inputChangeHandler}
              id=""
              className="rounded text-sm w-full border border-[#F4881F]/30 p-2 focus:outline-none"
            >
              <option value="">Choose A Year</option>
              {yearData.map((items, i) => (
                <option key={i} value={items}>
                  {items}
                </option>
              ))}
            </select>
          </div>

          <div className="flex justify-end">
            <button
              type="submit"
              className="bg-[#F4881F] p-2 mt-7 font-semibold text-sm px-5 rounded text-white hover:scale-105 ease-in-out duration-300"
            >
              Filter
            </button>
          </div>
        </form>
      </div>

      {/* Table */}
      <div className="mt-5 h-screen ">
        <VideoClassTable
          data={data?.recordings}
          page={page}
          entries={entries}
          cb={updateData}
        />
        <div className="flex justify-end mt-5">
          <Pagination
            Data={data?.recordings}
            page={page}
            setPage={setPage}
            getMethod={updateData}
            entries={entries}
          />
        </div>
      </div>

      {loading && <StudentLoader />}
    </div>
  );
};

export default ViewVideoClass;
